<template>
    <div>
        <div class="card course-calculator-card card-watermark" :style="errors.course_id ? 'border: 2px solid red;' : '' + ` --logo-url: url(${base_url}/storage/logo.png)`">
            <Accordion value="0">
                <AccordionPanel value="0">
                    <AccordionHeader>
                        <div class="accordion-header-content">
                            <div class="d-flex align-items-start">
                                <i class="fal fa-graduation-cap component-header-icon"></i>
                                <div>
                                    <h2 class="component-title">{{ tra.courses }}</h2>
                                    <p class="component-sub-title">{{ tra.select_suitable_course }}</p>
                                </div>
                            </div>
                            <div class="d-flex head-input-fields">
                                <div class="ml-3" @click.stop>

                                    <div class="floating-label-container">
                                        <label data-v-1542780d="" class="floating-label has-value">{{ tra.start_date }}
                                        </label>
                                        <DatePicker v-model="startDateValue" @date-select="setCurrentTime"
                                            :disabledDays="[0, 2, 3, 4, 5, 6]" :disabledDates="instituteVacationDates"
                                            :invalid="!startDateValue" :minDate="new Date()"
                                            :placeholder="tra.start_date" :showIcon="true" iconDisplay="input"
                                            icon="fal fa-calendar" size="small" dateFormat="dd-mm-yy" />
                                    </div>
                                </div>
                                <div @click.stop>
                                    <WeeksComponent v-model:weeks="courseWeeksValue" :placeholder="tra.study_duration"
                                        :tra="tra" />
                                </div>
                            </div>
                        </div>
                    </AccordionHeader>
                    <AccordionContent>
                        <div class="courses-container" style="position: relative;">
                            <!-- Loading overlay -->
                            <div v-if="isLoading" class="courses-loading-overlay">
                                <img :src="base_url + '/storage/circle-loader.gif'" alt="Loading..."
                                    class="loading-gif" />
                            </div>

                            <div v-for="course in courses" :key="course.id"
                                class="row align-items-end course-row py-2 justify-content-between">
                                <div class="col-md-auto">
                                    <div class="d-flex align-items-start">
                                        <RadioButton class="ml-3 mt-2" v-model="courseIdValue" :value="course.id"
                                            :inputId="'course_' + course.id" name="course_selection" />
                                        <div>
                                            <h2 class="course-title">{{ course.category.name }}</h2>
                                            <div>
                                                <Tag v-if="course.min_age" class="ml-2 course-tag" icon="fal fa-user"
                                                    :value="course.min_age + ' ' + tra.years" />

                                                <Tag v-if="course.study_period" class="ml-2 course-tag"
                                                    icon="fal fa-sun" :value="tra[course.study_period]" />

                                                <Tag v-if="course.lessons_per_week" class="ml-2 course-tag"
                                                    icon="fal fa-book"
                                                    :value="course.lessons_per_week + ' ' + getLessonText(course.lessons_per_week)" />
                                                <Tag v-if="course.hours_per_week" class="ml-2 course-tag"
                                                    icon="fal fa-clock"
                                                    :value="course.hours_per_week + ' ' + getHourText(course.hours_per_week)" />
                                                <Tag v-if="course.required_level" class="ml-2 course-tag"
                                                    icon="fal fa-sort-amount-up"
                                                    :value="tra.required_level + ' ' + course.required_level" />
                                                <Tag v-if="course.courseLanguage" class="ml-2 course-tag"
                                                    icon="fal fa-language"
                                                    :value="course.courseLanguage.name" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-auto" style="padding-right: 52px;">
                                    <div class="price-info d-flex align-items-end justify-content-md-end mt-2">
                                        <div class="d-flex ml-2 discounts-badges">
                                            <Tag v-if="course.prices.course_discount_obj.total_discounts"
                                                class="institute-discount-badge"
                                                :value="tra.institute_discount + ' ' + course.prices.course_discount_obj.total_discounts * 100 + '%'" />
                                            <Tag v-if="course.prices.sat_discount.value" class="mr-2 sat-discount-badge"
                                                :value="course.prices.sat_discount.label" />
                                        </div>

                                        <div v-if="course.prices.course_price !== course.prices.discounted_price"
                                            class="d-flex align-items-end">
                                            <del v-html="course.prices.course_price_formated" class="text-danger"></del>
                                            <p v-html="course.prices.discounted_price_formated" class="price mb-0 mr-2">
                                            </p>
                                        </div>
                                        <div v-else>
                                            <p v-html="course.prices.course_price_formated" class="price mb-0"></p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </AccordionContent>
                </AccordionPanel>
            </Accordion>
        </div>
    </div>




</template>

<script>
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import RadioButton from 'primevue/RadioButton';
import Tag from 'primevue/Tag';
import DatePicker from 'primevue/datepicker';
import Dropdown from 'primevue/dropdown';
import WeeksComponent from './WeeksComponent.vue';
import debounce from 'lodash/debounce';

export default {
    components: {
        Accordion,
        AccordionPanel,
        AccordionHeader,
        AccordionContent,
        RadioButton,
        Tag,
        DatePicker,
        Dropdown,
        WeeksComponent,
    },
    props: ['institute_id', 'base_url', 'pref_currency', 'startDate', 'courseWeeks', 'courseId', 'errors', 'old', 'employee_discount', 'instituteVacationDates', 'tra'],
    emits: ['update:startDate', 'update:courseWeeks', 'update:courseId'],
    data() {
        return {
            courses: [],
            isInitialized: false,
            isLoading: false,
        };
    },

    computed: {
        startDateValue: {
            get() {
                return this.startDate || new Date(new Date().setDate(new Date().getDate() + 7 + (1 + 7 - new Date().getDay()) % 7));
            },
            set(value) {
                this.$emit('update:startDate', value);
            }
        },

        courseWeeksValue: {
            get() {
                return this.courseWeeks;
            },
            set(value) {
                this.$emit('update:courseWeeks', value);
            }
        },

        courseIdValue: {
            get() {
                return this.courseId;
            },
            set(value) {
                this.$emit('update:courseId', value);
            }
        },

        // Check if we have minimum required data
        canFetchCourses() {
            return this.institute_id && this.startDateValue;
        }
    },

    watch: {
        startDateValue() {
            if (this.isInitialized && this.canFetchCourses) {
                this.debouncedGetCourses();
            }
        },
        courseWeeksValue() {
            if (this.isInitialized && this.canFetchCourses) {
                this.debouncedGetCourses();
            }
        }
    },

    methods: {
        getCourses() {
            if (!this.canFetchCourses) {
                return;
            }

            this.isLoading = true;

            axios.get(this.base_url + '/api/get-courses', {
                params: {
                    institute_id: this.institute_id,
                    weeks: this.courseWeeksValue,
                    start_date: this.startDateValue,
                    pref_currency: this.pref_currency,
                    employee_discount: this.employee_discount,
                    lang: window.current_locale,
                },
            }).then((response) => {
                // Ensure courses is always an array
                let coursesData = response.data;

                // If response is an object (not array), convert it to array
                if (coursesData && typeof coursesData === 'object' && !Array.isArray(coursesData)) {
                    coursesData = Object.values(coursesData);
                }

                // If response is null/undefined, set to empty array
                if (!coursesData) {
                    coursesData = [];
                }

                this.courses = coursesData;

                // Check if courseIdValue exists in the fetched courses
                if (this.courseIdValue && Array.isArray(this.courses) && this.courses.length > 0) {
                    const courseExists = this.courses.some(course => course.id === this.courseIdValue);
                    if (!courseExists) {
                        this.courseIdValue = null;
                    }
                }

                this.isLoading = false;
            }).catch((error) => {
                console.error('Error fetching courses:', error);
                this.isLoading = false;
                if (error.response && error.response.status === 429) {
                    console.warn('Rate limit exceeded for courses. Retrying in 2 seconds...');
                    setTimeout(() => {
                        this.getCourses();
                    }, 2000);
                }
            });
        },

        getLessonText(count) {
            if (count == 1) {
                return this.tra.lesson;
            } else if (count == 2) {
                return this.tra.two_lessons;
            } else {
                return this.tra.lessons;
            }
        },

        getHourText(count) {
            if (count == 1) {
                return this.tra.hour;
            } else if (count == 2) {
                return this.tra.two_hours;
            } else {
                return this.tra.hours;
            }
        },

        createDebouncedMethods() {
            this.debouncedGetCourses = debounce(this.getCourses, 800);
        }
    },

    created() {
        this.createDebouncedMethods();
    },

    mounted() {
        this.$nextTick(() => {
            // Emit initial values
            this.$emit('update:startDate', this.startDateValue);
            this.$emit('update:courseWeeks', this.courseWeeksValue);

            // Set old values if they exist
            if (this.old.course_id) {
                this.courseIdValue = Number(this.old.course_id);
            }
            if (this.old.start_date) {
                this.startDateValue = new Date(this.old.start_date);
            }
            if (this.old.course_weeks) {
                this.courseWeeksValue = Number(this.old.course_weeks);
            }


            // Delay initialization to prevent immediate API calls
            setTimeout(() => {
                this.isInitialized = true;
                if (this.canFetchCourses) {
                    this.getCourses();
                }
            }, 500);
        });
    },
};
</script>

<style scoped>
.courses-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.loading-gif {
    width: 50px;
    height: 50px;
}

.course-calculator-card {
    min-height: 150px;
}
</style>